/**
 * Cube-sphere mapping: each planet is six quadtree faces of a unit cube whose
 * points are normalized onto the sphere. Face bases are right-handed
 * (right x up = normal) so generated triangle winding always faces outward.
 */

export interface FaceBasis {
  normal: [number, number, number];
  right: [number, number, number];
  up: [number, number, number];
}

export const FACES: FaceBasis[] = [
  { normal: [1, 0, 0], right: [0, 0, -1], up: [0, 1, 0] }, // +X
  { normal: [-1, 0, 0], right: [0, 0, 1], up: [0, 1, 0] }, // -X
  { normal: [0, 1, 0], right: [1, 0, 0], up: [0, 0, -1] }, // +Y
  { normal: [0, -1, 0], right: [1, 0, 0], up: [0, 0, 1] }, // -Y
  { normal: [0, 0, 1], right: [1, 0, 0], up: [0, 1, 0] }, // +Z
  { normal: [0, 0, -1], right: [-1, 0, 0], up: [0, 1, 0] }, // -Z
];

/**
 * Map face-local cube coordinates (u, v in [-1, 1]) to a unit sphere
 * direction, written into `out` (length 3).
 */
export function faceDir(face: number, u: number, v: number, out: number[] | Float64Array): void {
  const f = FACES[face];
  let x = f.normal[0] + u * f.right[0] + v * f.up[0];
  let y = f.normal[1] + u * f.right[1] + v * f.up[1];
  let z = f.normal[2] + u * f.right[2] + v * f.up[2];
  const inv = 1 / Math.sqrt(x * x + y * y + z * z);
  out[0] = x * inv;
  out[1] = y * inv;
  out[2] = z * inv;
}
